<div class="p-grid p-mt-3">
  <kodit-card-container class="p-col-6">
    <div card-title>Plaćanje starih računa</div>
    <div class="p-d-flex p-flex-column gap-12" card-body>
      <kodit-placanje-racuna-import></kodit-placanje-racuna-import>
    </div>
  </kodit-card-container>
</div>
